<!-- <app-loading-bar></app-loading-bar> -->

<app-quickview></app-quickview>

<!-- mobilemenu -->
<app-mobile-menu></app-mobile-menu>
<!-- mobilemenu / end -->


<!-- <app-sidebar *ngIf="isLoggedIn" (emitMenuView)=getMenuViewStatus($event)></app-sidebar> -->

<!-- site -->
<div class="site" [ngClass]="{'full-menu-view': isLoggedIn && isFullmenu, 'half-menu-view': isLoggedIn && isFullmenu === false }">
    <!-- mobile site__header -->
    <header class="site__header  d-sm-block d-md-block d-lg-none" *ngIf="isLoggedIn">
        <app-mobile-header stickyMode="pullToShow"></app-mobile-header>
    </header>
    <!-- mobile site__header / end -->

    <!-- desktop site__header -->
    <!-- *ngIf="headerLayout" -->
    <header class="site__header d-sm-none none d-md-none d-lg-block " *ngIf="isLoggedIn">
        <app-header [layout]="headerLayout"></app-header>
    </header>

    <!-- <header class="site__header d-sm-block d-md-block d-lg-none" *ngIf="isLoggedIn">
        <div class="site-header">
            <div class="site-header__nav-panel">
                <div class="header-nav" style="justify-content: end;">
                  <app-header [layout]="headerLayout"></app-header>
                </div>
            </div>
        </div>
    </header> -->

    <header class="site__header" *ngIf="!isLoggedIn && (isCheckcoveragePage || changepassword) ">
        <div class="site-header">
            <div class="site-header__nav-panel">
                <div class="header-nav">
                   <img class ="Main_logo logo-homeconnect" src="../../../assets/images/megamenu/Main_logo.svg" alt="">
                   <button class="btn btn-light sign-inn" matButton (click)="signin()">Sign In</button>
                </div>
            </div>
        </div>
    </header>

    <!-- site__body -->
    <div class="site__body">
        <router-outlet></router-outlet>
    </div>
    <!-- site__body / end -->

    <!-- site__footer -->
    <footer class="site__footer d-lg-block d-none" *ngIf="isLoggedIn">
        <app-footer [isLoggedIn]="isLoggedIn"></app-footer>
    </footer>
    <!-- site__footer / end -->
</div>
<!-- site / end -->
